export enum ActivityTemplateMode {
  'CREATE' = 'CREATE',
  'UPDATE' = 'UPDATE',
  'VIEW' = 'VIEW',
}
